"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENT_STATUSES_BETS_ENABLED = exports.TEMPLATES_WITH_PARENTHESES = exports.TEMPLATES_WITH_PLUS_SIGN = exports.EVENT_PROBABILITY_EXCLUDE_TRADING_STATUSES = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
// Skip PROBABILITY_SETTLED
exports.EVENT_PROBABILITY_EXCLUDE_TRADING_STATUSES = [
    betweb_openapi_axios_1.EventProbabilityTradingStatus.Settled,
];
exports.TEMPLATES_WITH_PLUS_SIGN = ['H2Template', 'LH2Template'];
exports.TEMPLATES_WITH_PARENTHESES = [
    'G2Template',
    'LG2Template',
    'H2Template',
    'LH2Template',
];
exports.EVENT_STATUSES_BETS_ENABLED = [
    betweb_openapi_axios_1.EventStatus.Open,
    betweb_openapi_axios_1.EventStatus.Trading,
    betweb_openapi_axios_1.EventStatus.Planning,
];
//# sourceMappingURL=constants.js.map